<template>
	<div class="yzh-box" ref="listContainer" @scroll="handleScroll">
		<!-- 用户信息区 -->
		<div class="yzh-user" v-if="data">
			<img class="yzh-user-avatar" :src="data.headPortrait" alt="" />
			<div class="yzh-user-info">
				<span class="yzh-user-name">{{data.nickName}}</span>
				<span class="yzh-user-id">ID {{data.recodeCode}}</span>
				<div class="yzh-user-fan">
					<span class="yzh-user-fan-item">{{$t('all.guanzhu')}}： <span class="yzh-user-fan-num">{{data.followCount || 0}}</span></span>
					<span class="yzh-user-fan-item">{{$t('all.fensi')}}： <span class="yzh-user-fan-num">{{data.vermicelliCount || 0}}</span></span>
				</div>
			</div>
			<div class="yzh-user-follow" v-if="!isSelf" :class="{ 'yzh-user-follow--active': data.isFollowHe === 1 }" @click="toggleFollow">
				{{data.isFollowHe === 1 ? $t('all.yiguanzhu') : $t('all.guanzhuta')}}
			</div>
		</div>
		<!-- 视频列表区 -->
		<div class="yzh-video" v-if="appConfigInfo && appConfigInfo.videoStatus == 1">
			<div class="yzh-video-title">{{$t('all.shipin')}} {{videoList.length}}</div>
			<div class="yzh-grid" v-if="videoList.length > 0">
				<div class="yzh-card" v-for="(item, index) in videoList" :key="item.videoId || index" @click="handlePlayVideo(item)">
					<img v-if="item.coverUrl" class="yzh-card-cover" :src="item.coverUrl" />
					<div v-else class="yzh-card-cover yzh-card-cover--empty"></div>
					<div class="yzh-card-mask">
						<div class="yzh-card-likes">
							<img class="yzh-card-likes-icon" :src="dzIcon" />
							<span class="yzh-card-likes-num">{{item.giveLikeNumber || 0}}</span>
						</div>
						<div class="yzh-card-title">{{item.title || ''}}</div>
						<div class="yzh-card-meta">
							<span class="yzh-card-duration">{{item.duration ? formatDuration(item.duration) : '00:00'}}</span>
						</div>
					</div>
				</div>
			</div>
			<kong v-if="!videoLoading && loaded && videoList.length === 0"></kong>
		</div>
	</div>
</template>

<script>
import { viewUserInfo, viewUserVideoList, followOrCancelFollow, getAppConfigInfo } from '@/api/user';
import kong from '../../../components/kong/kong.vue';
import dzIcon from '../../../assets/image/sp_dz_1@2x.png';
export default {
	components: {
		kong
	},
	data() {
		return {
			userId: '',
			data: '',
			appConfigInfo: null,
			videoList: [],
			videoPage: 1,
			videoSize: 10,
			videoLoading: false,
			videoHasMore: true,
			loaded: false,
			followLoading: false,
			dzIcon: dzIcon
		};
	},
	computed: {
		// 是否查看自己的主页
		isSelf() {
			if (!this.data || !this.$store.state.userInfo) return false;
			const selfId = this.$store.state.userInfo.userId;
			const pageId = this.data.userId;
			return selfId && pageId && String(selfId) === String(pageId);
		}
	},
	mounted() {
		this.userId = this.$route.query.userId || '';
		this.getUserInfo();
		this.getVideoList();
		this.getAppConfigInfo();
	},
	methods: {
		// 用户详情
		async getUserInfo() {
			if (!this.userId) return;
			try {
				const res = await viewUserInfo({ viewUserId: this.userId });
				this.data = res.data;
			} catch (e) {
				console.error('获取用户详情失败:', e);
			}
		},
		async getAppConfigInfo() {
			try {
				const res = await getAppConfigInfo();
				this.appConfigInfo = res.data;
			} catch (e) {
				console.error('获取配置失败:', e);
			}
		},
		// 他人的短影音列表(分页)
		async getVideoList() {
			if (!this.userId || this.videoLoading || !this.videoHasMore) return;
			this.videoLoading = true;
			try {
				const res = await viewUserVideoList({
					page: this.videoPage,
					size: this.videoSize,
					viewUserId: this.userId
				});
				const rows = res.rows || [];
				this.videoList = this.videoPage === 1 ? rows : [...this.videoList, ...rows];
				if (rows.length < this.videoSize) this.videoHasMore = false;
				this.videoPage++;
				this.loaded = true;
			} catch (e) {
				console.error('获取短影音列表失败:', e);
			} finally {
				this.videoLoading = false;
			}
		},
		// 滚动加载更多
		handleScroll() {
			const container = this.$refs.listContainer;
			if (!container) return;
			const isAtBottom = container.scrollTop + container.clientHeight >= container.scrollHeight - 50;
			if (isAtBottom) this.getVideoList();
		},
		// 关注 / 取消关注
		async toggleFollow() {
			if (!this.userId || this.followLoading) return;
			this.followLoading = true;
			try {
				const res = await followOrCancelFollow({ viewUserId: this.userId });
				const wasFollowed = this.data.isFollowHe === 1;
				this.data = {
					...this.data,
					isFollowHe: wasFollowed ? 0 : 1,
					followCount: wasFollowed ? Math.max(this.data.followCount - 1, 0) : this.data.followCount + 1
				};
				if (res && res.msg) this.$message.success(res.msg);
			} catch (e) {
				console.error('关注操作失败:', e);
			} finally {
				this.followLoading = false;
			}
		},
		// 跳转视频播放详情页
		handlePlayVideo(item) {
			this.$router.push({
				path: '/bofangshipin',
				query: {
					userId: this.userId,
					videoId: item.videoId || item.id || ''
				}
			});
		},
		formatDuration(seconds) {
			if (!seconds) return '00:00';
			const mins = Math.floor(seconds / 60);
			const secs = Math.floor(seconds % 60);
			return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
		}
	}
};
</script>

<style scoped lang="scss">
	@import "./yonghuzhuye.css";
</style>



// WEBPACK FOOTER //
// yonghuzhuye.vue?65728d6d